import AssignMePripomienkaButton from './AssignMePripomienkaButton';

export default AssignMePripomienkaButton;
